import React, { useEffect } from 'react';
import { debounce } from 'lodash';

import styles from './PageWrapper.module.scss';
import ModalLink from '../../components/Shared/Modal/ModalLink/ModalLink';
import { EXIT_MODAL } from '../../redux/modules/modals/modals.module';
import { useSelector } from 'react-redux';
import { getSalesforceRep } from '../../redux/modules/applicationConfig/applicationConfig.selectors';

const PageWrapper = ({ children, step, isHelpCol }) => {
  const isSalesforceRep = useSelector((state) => getSalesforceRep(state));

  useEffect(() => {
    const storeScroll = () => {
      document.documentElement.dataset.scroll = window.scrollY;
    };
    document.addEventListener('scroll', debounce(storeScroll), {
      passive: true,
    });
    storeScroll();
    return () => {
      document.removeEventListener('scroll', storeScroll);
    };
  }, []);

  return (
    <>
      <div className={`${isHelpCol ? styles.container : styles.center}`}>
        {children}
      </div>
      <div className={styles['exit-container']}>
        {!isSalesforceRep && (
          <ModalLink
            link={<div className={styles['exit-link']}>Exit Auto-RMD</div>}
            linkStyle="link"
            modalProps={{
              url: 'https://www.troweprice.com/usis/rmd-tool',
              local: true,
            }}
            modalName={EXIT_MODAL}
          />
        )}
      </div>
      <p className={styles['lrn-number']}>3292270</p>
    </>
  );
};

export default PageWrapper;
